import React, { useState } from 'react'; // Added useState
import { motion } from 'framer-motion'; // Import motion if needed for internal animations, though primary is in HomePage

// Accept onStartTest and isLoading as props
const ServerTestSection = () => {

  // Removed ipAddress state and handlers

  return (
    // Keep mb-8 here for spacing before the ServerInfoCard
    <div className="mb-8 transform-gpu hover:scale-[1.01] transition-medium">
      <div className="relative overflow-hidden bg-gradient-to-r from-dark-500 to-dark-400 rounded-2xl p-6 md:p-8 border border-dark-400 hover:border-accent-purple/30 transition-medium group">
        {/* Background effects */}
        <div className="absolute -right-20 -top-20 w-64 h-64 bg-accent-purple opacity-[0.03] rounded-full blur-3xl group-hover:opacity-[0.06] transition-opacity duration-300"></div>
        <div className="absolute -left-20 -bottom-20 w-64 h-64 bg-accent-pink opacity-[0.03] rounded-full blur-3xl group-hover:opacity-[0.06] transition-opacity duration-300"></div>

        <div className="flex flex-col md:flex-row items-center justify-between z-10 relative">
          {/* Left side: Text */}
          <div className="w-full md:w-2/5 mb-6 md:mb-0 text-center md:text-left">
            <div className="inline-flex items-center text-sm font-medium text-accent-pink mb-2 animate-pulse-slow bg-accent-pink/10 px-3 py-1 rounded-full">
              SERVER TESTING PLATFORM
            </div>
            <h2 className="text-3xl font-bold mb-3 group-hover:text-white transition-colors">
              StormHack
              <span className="gradient-text inline-block ml-2 group-hover:animate-pulse-text">Reloaded</span>
            </h2>
            <p className="text-gray-400 text-sm max-w-md mx-auto md:mx-0 group-hover:text-gray-300 transition-colors">
              Connect to a server below to start comprehensive security testing and discover vulnerabilities.
            </p>
            {/* Input and Button Area REMOVED */}
          </div>

          {/* Right side: SVG Graphic */}
          <div className="w-full md:w-3/5 md:pl-8 flex items-center justify-center md:justify-end opacity-60 md:opacity-100 group-hover:opacity-100 transition-opacity duration-300 mt-6 md:mt-0">
            <div className="relative w-full max-w-md animate-float transform-gpu group-hover:scale-105 transition-transform duration-500">
              {/* SVG content... (keep as is) */}
               <svg viewBox="0 0 500 260" xmlns="http://www.w3.org/2000/svg" className="w-full">
                 {/* Server graphic */}
                 <rect x="150" y="80" width="200" height="140" rx="10" fill="#211c2d" stroke="#342d47" strokeWidth="2"/>

                 {/* Server lights */}
                 <circle cx="170" cy="100" r="5" fill="#ff3c3c" className="animate-pulse-slow"/>
                 <circle cx="170" cy="120" r="5" fill="#3effb8" className="animate-pulse-slow delay-150"/>
                 <circle cx="170" cy="140" r="5" fill="#ffce3c" className="animate-pulse-slow delay-300"/>

                 {/* Server slots */}
                 <rect x="190" y="95" width="140" height="10" rx="2" fill="#342d47"/>
                 <rect x="190" y="115" width="140" height="10" rx="2" fill="#342d47"/>
                 <rect x="190" y="135" width="140" height="10" rx="2" fill="#342d47"/>
                 <rect x="190" y="155" width="140" height="10" rx="2" fill="#342d47"/>

                 {/* Connection lines */}
                 <path d="M250 80 L250 40 L100 40 L100 200 L150 200" stroke="#9e3eff" strokeWidth="2" fill="none" className="animate-draw-line"/>
                 <path d="M250 220 L250 260 L400 260 L400 100 L350 100" stroke="#ff3cb4" strokeWidth="2" fill="none" className="animate-draw-line delay-500"/>

                 {/* Pulsing dots */}
                 <circle cx="100" cy="40" r="5" fill="#9e3eff" className="animate-ping-slow"/>
                 <circle cx="400" cy="260" r="5" fill="#ff3cb4" className="animate-ping-slow delay-700"/>

                 {/* Shield overlay */}
                 <path d="M250 30 L310 60 L310 150 L250 180 L190 150 L190 60 Z" fill="none" stroke="#3ca9ff" strokeWidth="1.5" opacity="0.5" className="animate-shield-pulse"/>

                 {/* Hacking symbols */}
                 <text x="210" y="205" fill="#3ca9ff" fontFamily="monospace" fontSize="8">SCANNING PORT 25565</text>
                 <text x="140" y="75" fill="#ff3cb4" fontFamily="monospace" fontSize="8">RCON ACCESS_</text>
              </svg>
              {/* Animated particles */}
              <div className="absolute inset-0 pointer-events-none">
                <div className="particle-1"></div>
                <div className="particle-2"></div>
                <div className="particle-3"></div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ServerTestSection;